import { Component, inject } from '@angular/core';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { routePath } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-survey-money-help-card',
    imports: [BrightsideUiModule, TranslateModule],
    templateUrl: './survey-money-help-card.component.html',
    styleUrl: './survey-money-help-card.component.css'
})
export class SurveyMoneyHelpCardComponent {
  data: { surveyType: string | undefined };
  private _router = inject(Router);

  cellClick($event: any) {   
    if (this.data?.surveyType) {
      this._router.navigate(['survey', this.data.surveyType, 'view']);
    } else {
      this._router.navigate([routePath('survey_info_view')]);
    }
  }
}
